import React from 'react';
import { createRoot } from 'react-dom/client';
import './index.css';
import { PublicClientApplication } from '@azure/msal-browser';
import { MsalProvider } from '@azure/msal-react';
import { msalConfig } from './authConfig';
import App from './App';
import env from './common/env';
import * as serviceWorker from './serviceWorker';
import newrelic from './modules/newrelic/newrelic';

// MSAL uses Web Crypto (crypto.subtle), which browsers only expose on secure origins
// (HTTPS) and on http://localhost / http://127.0.0.1 — not on http://some.custom.host.
if (typeof window !== 'undefined') {
  const host = window.location.hostname;
  const isLocalhost = host === 'localhost' || host === '127.0.0.1' || host === '[::1]';
  if (!window.isSecureContext && !isLocalhost) {
    throw new Error(
      `Azure MSAL needs a secure context (HTTPS or localhost). Current origin: ${window.location.origin}. ` +
        'For local.evergreen.pearson.com run: npm run start:evergreen — then open https://local.evergreen.pearson.com:3000'
    );
  }
}

const msalInstance = new PublicClientApplication(msalConfig);
const container = document.getElementById('root');
const root = createRoot(container);
root.render(
  <MsalProvider instance={msalInstance}>
    <App />
  </MsalProvider>
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
/* Dynamicly includes the Newrelic */
if (env.NEWRELIC_ENABLED) {
  newrelic.init();
}
